// API service for handling custom API communication
import { getOpenAIInstance, generateCatalogResponse } from './openai'
// ChatGPT shopping expert link
const SHOPPING_EXPERT_LINK =
  'https://chatgpt.com/g/g-68986d8f22748191b0f4b8839c3e1cfa-shopping-expert'
// Default fallback responses when API is not configured
const getFallbackResponse = (message: string) => {
  if (message.toLowerCase().includes('laptop')) {
    return `I found some great laptop options for you:
    1. [TechPro UltraBook X5](${SHOPPING_EXPERT_LINK}) - $899
    2. [PowerBook Pro 2023](${SHOPPING_EXPERT_LINK}) - $1299
    3. [LightWeight Air 15](${SHOPPING_EXPERT_LINK}) - $799
    Would you like more details about any of these?`
  } else if (message.toLowerCase().includes('headphone')) {
    return `Here are some popular headphones:
    1. [SoundMaster Pro](${SHOPPING_EXPERT_LINK}) - $199
    2. [AudioPhile Wireless](${SHOPPING_EXPERT_LINK}) - $149
    3. [BassBoost X3](${SHOPPING_EXPERT_LINK}) - $89
    All of these have great reviews. Do any catch your interest?`
  } else {
    return `I'd be happy to help you find the perfect product. Could you tell me more about what you're looking for? For example, are you interested in electronics, home goods, clothing, or something else?`
  }
}
// Send message to API
export const sendMessageToApi = async (messages: any[]): Promise<string> => {
  try {
    // Try to use OpenAI if available
    getOpenAIInstance() // Just check if initialized
    return await generateCatalogResponse(messages)
  } catch (error) {
    console.warn('OpenAI API error:', error)
    // If OpenAI fails, use simple fallback
    const lastMessage = messages[messages.length - 1].content
    return getFallbackResponse(lastMessage)
  }
}
